var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"menu"}},[_vm._v("\n    메뉴 페이지\n    "),_c('div',{on:{"click":_vm.gosignup}},[_vm._v("가입하기")]),_vm._v(" "),_c('div',{on:{"click":_vm.gopreview}},[_vm._v("미리보기")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-603691ed","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/showcase/Menu.vue
// module id = null
// module chunks = 